import { Flag } from '@fullstory/proto/fs/shared/flags';
import { useFlags } from '@fullstory/react-hooks';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MetricAlertsRequestActions } from '.';
import { AppDispatch } from '../..';
import { getOrgId } from '../fullstory/selectors';
import { getMetricAlertsByMetric } from './selectors';

export const useUpdateAlertsForMetric = () => {
  const orgId = useSelector(getOrgId);
  const flags = useFlags();
  const dispatch = useDispatch<AppDispatch>();
  const metricAlertsEnabled = flags.hasBit(Flag.FeatAlerts);
  const alertsByMetric = useSelector(getMetricAlertsByMetric);

  const updateAlertsForMetric = useCallback(
    async (metricId: string | undefined) => {
      if (metricAlertsEnabled && metricId) {
        const alertsForMetric = alertsByMetric[metricId];
        const alertIds = alertsForMetric?.map(alert => alert.alertId);
        await dispatch(MetricAlertsRequestActions.updateAlertsForMetric(orgId, metricId, alertIds));
        dispatch(MetricAlertsRequestActions.getAlertsListView(orgId, metricId));
      }
    },
    [alertsByMetric, dispatch, metricAlertsEnabled, orgId],
  );

  return updateAlertsForMetric;
};
